/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'ToolSet'>;
const hooks = useModelQueries(schema, 'ToolSet');

export const useAggregateToolSet: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountToolSet: Hooks['useCount'] = hooks.useCount;
export const useCreateToolSet: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyToolSet: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnToolSet: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteToolSet: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyToolSet: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsToolSet: Hooks['useExists'] = hooks.useExists;
export const useFindFirstToolSet: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyToolSet: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueToolSet: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByToolSet: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyToolSet: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateToolSet: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountToolSet: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstToolSet: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyToolSet: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueToolSet: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByToolSet: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyToolSet: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateToolSet: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyToolSet: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnToolSet: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertToolSet: Hooks['useUpsert'] = hooks.useUpsert;
